import * as _ from "lodash";
import * as angular from "angular";
import { Issue } from "../../../models/issue.model";
import { DialogUtils } from "../../../helper/dialog.helper";
import { IssueDataProvider } from "../../../data-provider/issue.dp";

let IssuePriorityComponent = {
    selector: "vcIssuePriority",
    templateUrl:
        "/angular/components/issue/modals/issue-priority.component.html",
    bindings: {
        selectedIssue: "=",
    },
    controller: class IssuePriorityController {
        // * bindings for typescript compiler *
        public selectedIssue: Issue;
        // ************************************

        private dataProvider: IssueDataProvider;
        private dialog: DialogUtils;

        public issue: Issue;
        public priorities: Array<any>;

        constructor(
            DialogUtils: DialogUtils,
            IssueDataProvider: IssueDataProvider
        ) {
            this.dataProvider = IssueDataProvider;
            this.dialog = DialogUtils;

            this.dataProvider.getPriorities().then((priorities) => {
                this.priorities = priorities;
            });
        }

        $onInit() {
            this.issue = _.cloneDeep(this.selectedIssue);
        }

        confirm(): void {
            this.dialog.hide(this.issue);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("issue")
    .component(IssuePriorityComponent.selector, IssuePriorityComponent);
